import React, { FC, useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import {
    Dialog,
    IconButton,
    Button,
    Stack,
    ButtonGroup, 
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Switch,
    Link,
    Checkbox,
} from '@material-ui/core'
import "firebase/analytics"
import firebase from "firebase/app"
import useStore from 'store'
import { useTranslation } from 'react-i18next'
import { theme, Text, Row, Space, Icon } from 'ui'
import { observer } from 'mobx-react'


const StyledCookieContainer = styled.div`
  z-index: 1200; 
  position: fixed; 
  bottom: 0; 
  left: 0; 
  text-align: center;  
  width: 100%;
  padding: 8px 5px;
  color: white;
  background-color:rgba(0, 0, 0, 0.5);
`

const StyledLink = styled(Link)`
  color: #1ed14b;
  padding-right: 3px;
`

const StyledButton = styled(Button)`
  margin-right: 60px;
  border-radius: 15px;
  background: white;
  border: 4x;
  padding: 2px 5px;
  &:hover {
    background: #f6f7f7;
  }
`


const CookieBunner: FC = () => {
    const { t } = useTranslation('budget')
    const { modulesStore } = useStore()
    
    return (!modulesStore.cookiePolicyPresentState) ? (
      <StyledCookieContainer>
        {t`app:cookie_text`} 
        <StyledLink style={{ cursor: "pointer" }} onClick={() => {
          modulesStore.openCookiePolicyModal();
        }}>
          {t`app:cookie_learn_more`}
        </StyledLink>
        <StyledButton color="primary" variant="outlined" onClick={() => {
          localStorage.setItem('@cookie_consent', JSON.stringify({ necessary: true, statistics: true }));
          try {
            firebase.initializeApp({
              apiKey: "AIzaSyAQT_cb0iRVbPK-lmHLJaZgqwaFaJJGxAc",
              authDomain: "soy-zone-750.firebaseapp.com",
              databaseURL: "https://soy-zone-750.firebaseio.com",
              projectId: "soy-zone-750",
              storageBucket: "soy-zone-750.appspot.com",
              messagingSenderId: "464930886928",
              appId: "1:464930886928:web:a348cb93f215f2f4f7c195",
              measurementId: "G-3X7VNQ762T"
            });
                                 
            firebase.analytics();
          } catch (e) {
            console.log("firebase.initializeApp error", e)
          } finally {
            modulesStore.cookiePolicyPresentState = true
          }
        }}>{t`app:gotIt`}</StyledButton>
      </StyledCookieContainer> 
    ) : (<></>)
}

export default observer(CookieBunner)


